/** @jsxImportSource @emotion/react */
import type { JSX } from 'react';

import { Heading } from 'components/Heading';
import { CustomSignupProps } from 'pages/SignUp/types';
import { useStyles } from 'utils/useStyles';

import { BulletRenderer } from './BulletRenderer';
import { customSignupStyles } from './CustomSignup.styles';

export const CustomSignup = ({ customContent }: CustomSignupProps): JSX.Element => {
  const styles = useStyles((theme) => customSignupStyles(theme, !!customContent.description));

  return (
    <div key={customContent.key}>
      <div css={styles.iconsWrapper}>
        {customContent.imgSrc.length > 0 && (
          <picture css={customContent.isHeroImg ? styles.dashboardImg : styles.iconImg}>
            <img src={`${customContent.imgSrc}`} alt={`${customContent.imgAlt} logo`} />
          </picture>
        )}
        <Heading type="1" css={styles.header}>
          {customContent.title}
        </Heading>
        {customContent.description && <p css={styles.description}>{customContent.description}</p>}
      </div>
      <div css={styles.textWrapper}>
        <BulletRenderer listItems={customContent.bullets} isNumber={customContent.isNumber} />
      </div>
      {customContent.footer && <p css={styles.description}>{customContent.footer}</p>}
    </div>
  );
};
